import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { NoteGroup } from "../interfaces/note-group.interface";
import { Note } from "../interfaces/note.interface";
import { HttpContextTokens, HttpLoggingOptions } from "common";

@Injectable({
  providedIn: 'root',
})
export class NotesApiService {
  http = inject(HttpClient);

  private httpContext: HttpContext = null;

  constructor() {
    this.initialiseHttpContext();
  }

  private initialiseHttpContext(): void {
    if (this.httpContext === null) {
      this.httpContext = new HttpContext();
      var httpLoggingOptions = new HttpLoggingOptions();
      httpLoggingOptions.setDisplaySuccess('POST', false);
      this.httpContext.set(HttpContextTokens.options, httpLoggingOptions);
    }
  }

  getNotes$(noteGroup: NoteGroup, referenceId: number) {
    return this.http.get<Note[]>(`/senderidregistry/manage/note/note-group/${noteGroup}/reference-id/${referenceId}`);
  }

  addNote$(noteGroup: NoteGroup, referenceId: number, noteText: string, file?: File) {
    const formData = new FormData();

    formData.append('noteGroup', noteGroup.toString());
    formData.append('referenceId', referenceId.toString());
    formData.append('noteText', noteText);

    if (file) {
      formData.append('fileContent', file, file.name);
    }

    return this.http.post<Note>(`/senderidregistry/manage/note/note-group/${noteGroup}/reference-id/${referenceId}`, formData, { context: this.httpContext });
  }

  downloadAttachment$(noteId: number, guid: string) {
    return this.http.get(`/senderidregistry/manage/note/${noteId}/attachment/${guid}`, { responseType: 'blob' });
  }
}
